module.exports = __webpack_public_path__ + "static/img/logo-tk-alpha.15bbcac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-tk-alpha.png
// module id = rw0C
// module chunks = 1